import { Folder, GetAllFoldersResponse, UpdateFolderResponse } from 'stockblocks-client';

export enum StockItemContext {
    SIMILAR_CONTENT = 'similarContent',
    DETAILS_PLAYER = 'detailsPlayer',
    DRAWER = 'drawer',
    FOLDER = 'folder',
    BUILDER = 'builder',
    SEARCH = 'search',
    GLOBAL_PLAYER = 'globalPlayer',
    CROSS_ASSET_COLLECTION = 'crossAssetCollection',
    CONTENT_TYPE = 'contentType',
    STORYBOARD = 'storyboard',
}

export interface FolderGroup {
    folders: Record<string, Folder>;
    getAllFolders: () => Promise<GetAllFoldersResponse>;
    removeStockItemsFromFolder: (folderUniqueId: string, contentIds: number[]) => Promise<UpdateFolderResponse>;
    addStockItemsToFolder: (folderUniqueId: string, contentIds: number[]) => Promise<UpdateFolderResponse>;
    createFolder: (name: string, contentIds?: number[]) => Promise<UpdateFolderResponse>;
}

export interface DownloadGroup {
    canDownload: boolean;
    getCanDownloadState: () => Promise<boolean>;
    getUserID: () => Promise<number>;
}

export interface StockItemUserData {
    isLoggedIn: boolean;
    folderGroup: FolderGroup;
    downloadGroup: DownloadGroup;
    getLoggedInState: () => Promise<boolean>;
}

export enum StockItemDrawerType {
    ALT_VERSIONS = 'altVersions',
    RECOMMENDED_MUSIC = 'recommendedMusic',
}
